import { message } from "antd"
import { checkPreviousDataExam, previousDataExam } from "services/exam/convertType"

const setState = (props, data,) => {
  return {
    data: data?.previousData ? data.data || data.data.data : data,
    groupId: data?.previousData ? data?.groupId : props?.groupId,
    time: data?.previousData ? data.data.data?.testingDuration?.endTimestamp : data?.testingDuration?.endTimestamp ? parseInt(data.testingDuration.endTimestamp * 1000) : null,
    typeExam: 'groupExam'
  }
}

export const enterGroupTesting = (props, data) => {
  try {
    if (checkPreviousDataExam(props, data)) {
      data = previousDataExam(props, data)
    }
    if (data?.previousData && data?.groupId) {
      const previousData = data
      return props?.history?.push({
        pathname: `/testing/${previousData?.data?.id || previousData.data?.data?.id}`, state: setState(props, previousData),
        search: `groupId=${previousData?.groupId}&typeExam=groupExam`
      })
    }
    return props?.props?.history?.push({
      pathname: `/testing/${data.id}`, state: setState(props, data),
      search: 'groupId=' + props?.groupId + '&' + 'typeExam=groupExam'
    })
  } catch (error) {
    message.error('เกิดข้อผิดพลาดก่อนเข้าทำข้อสอบ', [3])
    return props?.props?.history.goBack() || props.props?.props?.history.goBack() || props?.history.goBack()
  }
}